import { css } from "simplydo/react/styled";

import { Icon } from "../icon";
import { Label } from "../label";

export const headingBaseClass = css`
  border: none;
  margin: 1rem 0;
  padding: 0;
  font-family: inherit;
  font-weight: bold;
  line-height: 1.3em;
  text-transform: none;

  a {
    color: rgba(0, 0, 0, 0.87);
  }

  ${Icon}:first-child {
    margin-right: 0.3rem;
  }

  > ${Label} {
    margin-left: 0.5rem;
  }

  &:first-child {
    margin-top: 0;
  }

  &:only-child {
    margin: 0;
  }
`;
